<script>
    import DisplayRow from "../../../components/DisplayRow.svelte";
    import FormRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import RadioGroup from "../../../components/RadioGroup.svelte";

    import FurtherSurgery from "./FurtherSurgery.svelte";

    export let surgeries = [];
    export let disabled = null;

    const surges = [
        { label: "Remove all or part of Implant", selected: false, dates: [] },
        { label: "Release arms of Implant", selected: false, dates: [] },
        { label: "Remove scar tissue", selected: false, dates: [] },
        { label: "Explore cause of condition/symptom", selected: false, dates: [], additional: null },
    ]

 	export const furtherSurgeries = {

       getFurtherSurgeries() {
            let updatedSurgeries = [];

            surges.forEach(s => {
                let selectedSurgeries = surgeries.filter(_ => _.additionalSurgeryPurpose == s.label)

                if (selectedSurgeries.length && !s.selected) {
                    selectedSurgeries.forEach(_ => _.deleted = true);
                } else if (s.selected) {
                    s.dates.filter(d => !!d.date)
                        .forEach(d => {
                            updatedSurgeries.push({
                                isFurtherSurgery: true,
                                addedByQuestionnaire: true,
                                surgeryId: d.id,
                                dateSurgery: d.date,
                                additionalSurgeryPurpose: s.label,
                                implantCauseOfCondition: s.additional,
                            });
                    });
                }
            });

            surgeries = [ ...updatedSurgeries ];

            console.info("Processing Further Surgeries", surgeries);
        }
    }

    const initialise = () => {
        surges.forEach(s => {
            let arr = surgeries.filter(_ => _.additionalSurgeryPurpose == s.label)
            if (arr.length) {
                s.selected = true;
                s.dates = arr.map(d => ({ date: d.dateSurgery, id: d.surgeryId }));
                s.additional = arr[0].implantCauseOfCondition;
            }
        })
    }

    initialise();
</script>

<div class="mt-4">

    <DisplayRow>
        <FormColumn cols="5">
            <p class="label">List of Further Surgeries</p>
        </FormColumn>
        <FormColumn cols="5">
            <p class="label">Date of Surgery</p>
        </FormColumn>
        <FormColumn cols="2">
        </FormColumn>
    </DisplayRow>

    <FurtherSurgery {disabled} label={surges[0].label} bind:selected={surges[0].selected} bind:dates={surges[0].dates} />
    <FurtherSurgery {disabled} label={surges[1].label} bind:selected={surges[1].selected} bind:dates={surges[1].dates} />
    <FurtherSurgery {disabled} label={surges[2].label} bind:selected={surges[2].selected} bind:dates={surges[2].dates} />
    <FurtherSurgery {disabled} label={surges[3].label} bind:selected={surges[3].selected} bind:dates={surges[3].dates} />

    {#if surges[3].selected}
        <DisplayRow>
            <FormColumn>
                <RadioGroup
                    {disabled}
                    required
                    name="implantCauseOfCondition"
                    label="Was the Implant found to be one of the causes of your condition/symptom?"
                    bind:value={surges[3].additional}
                    optionList={[
                        { name: "Yes" },
                        { name: "No" },
                        { name: "Don't know" },
                    ]}
                    labelProperty="name"
                    valueProperty="name"
                ></RadioGroup>
            </FormColumn>
        </DisplayRow>
    {/if}

</div>
